// import { useState, useEffect } from 'react';
// import axios from 'axios';

// const ApplyJob = () => {
//   const [mode, setMode] = useState('seeker'); // 'seeker' for job seeker, 'employer' for job employer
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     companyName: '',
//     email: '',
//     phoneNumber: '',
//     whatsappNumber: '',
//     location: '',
//     jobType: '',
//   });
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const type = mode === 'seeker' ? 'apply job-jobseekers' : 'hire for job-jobEmployer';
//     const submissionData = { ...formData, type };
//     setLoading(true);

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API_URL}submit`, submissionData);
//       console.log('Submission response:', response.data);
//       alert(response.data.message || 'Form submitted successfully!');
//       fetchJobs(); // Refresh the job list after submission
//       setFormData({
//         firstName: '',
//         lastName: '',
//         companyName: '',
//         email: '',
//         phoneNumber: '',
//         whatsappNumber: '',
//         location: '',
//         jobType: '',
//       });
//     } catch (error) {
//       console.error('Error submitting form:', error.response?.data || error.message);
//       alert(error.response?.data?.message || 'Error submitting form.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchJobs = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}jobs`);
//       setJobs(response.data);
//     } catch (error) {
//       console.error('Error fetching jobs:', error);
//     }
//   };

//   useEffect(() => {
//     fetchJobs();
//   }, []);

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-start p-4">
//       <div className="bg-blue-100 p-6 rounded-t-lg shadow-lg w-full" style={{ marginTop: '64px', maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' }}>
//         <h1 className="text-blue-800 text-2xl font-bold mb-6 text-center">Apply Job</h1>
//         <div className="flex justify-center mb-6">
//           <button
//             onClick={() => setMode('seeker')}
//             className={`px-6 py-3 rounded-l-md text-white font-semibold ${mode === 'seeker' ? 'bg-blue-600' : 'bg-blue-300'}`}
//           >
//             Looking for Job
//           </button>
//           <button
//             onClick={() => setMode('employer')}
//             className={`px-6 py-3 rounded-r-md text-white font-semibold ${mode === 'employer' ? 'bg-blue-600' : 'bg-blue-300'}`}
//           >
//             Hire Person
//           </button>
//         </div>
//         <form onSubmit={handleSubmit} className="space-y-6">
//           {mode === 'seeker' ? (
//             <>
//               <div>
//                 <label className="block text-gray-700 text-lg">First name</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   placeholder="Enter First name"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Last name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   placeholder="Enter Last name"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="Enter email address"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phoneNumber"
//                   value={formData.phoneNumber}
//                   onChange={handleChange}
//                   placeholder="Enter Phone Number"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Whatsapp Number</label>
//                 <input
//                   type="tel"
//                   name="whatsappNumber"
//                   value={formData.whatsappNumber}
//                   onChange={handleChange}
//                   placeholder="Enter Whatsapp Number"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Location</label>
//                 <input
//                   type="text"
//                   name="location"
//                   value={formData.location}
//                   onChange={handleChange}
//                   placeholder="Enter your location"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Which type of job are you looking for</label>
//                 <select
//                   name="jobType"
//                   value={formData.jobType}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 >
//                   <option value="">Select option</option>
//                   <option value="UI/UX">UI/UX</option>
//                   <option value="Dev Ops">Dev Ops</option>
//                 </select>
//               </div>
//             </>
//           ) : (
//             <>
//               <div>
//                 <label className="block text-gray-700 text-lg">Company name</label>
//                 <input
//                   type="text"
//                   name="companyName"
//                   value={formData.companyName}
//                   onChange={handleChange}
//                   placeholder="Enter Company name"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Contact Name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   placeholder="Enter Last name"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="Enter email address"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phoneNumber"
//                   value={formData.phoneNumber}
//                   onChange={handleChange}
//                   placeholder="Enter Phone Number"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Location</label>
//                 <input
//                   type="text"
//                   name="location"
//                   value={formData.location}
//                   onChange={handleChange}
//                   placeholder="Enter your location"
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 text-lg">Which type of job did you want to for</label>
//                 <select
//                   name="jobType"
//                   value={formData.jobType}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
//                   required
//                 >
//                   <option value="">Select option</option>
//                   <option value="UI/UX">UI/UX</option>
//                   <option value="Dev Ops">Dev Ops</option>
//                 </select>
//               </div>
//             </>
//           )}
//           <button
//             type="submit"
//             className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
//             disabled={loading}
//           >
//             {loading ? 'Submitting...' : 'Submit'}
//           </button>
//         </form>
//         <div className="mt-8">
//           <h2 className="text-2xl font-semibold text-blue-800 mb-4 text-center">Submitted Jobs</h2>
//           {jobs.length > 0 ? (
//             <ul className="space-y-4">
//               {jobs.map((job) => (
//                 <li key={job._id} className="p-4 bg-white rounded-lg shadow-md">
//                   <h3 className="text-xl font-semibold">{job.type.includes('jobseekers') ? 'Job Seeker Details' : 'Job Posting'}</h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
//                     <p><strong>Type:</strong> {job.type}</p>
//                     {job.type.includes('jobseekers') ? (
//                       <>
//                         <p><strong>First Name:</strong> {job.firstName}</p>
//                         <p><strong>Last Name:</strong> {job.lastName}</p>
//                         <p><strong>Email:</strong> {job.email}</p>
//                         <p><strong>Phone:</strong> {job.phoneNumber}</p>
//                         <p><strong>Whatsapp:</strong> {job.whatsappNumber || 'N/A'}</p>
//                       </>
//                     ) : (
//                       <>
//                         <p><strong>Company:</strong> {job.companyName}</p>
//                         <p><strong>Contact Name:</strong> {job.lastName}</p>
//                         <p><strong>Email:</strong> {job.email}</p>
//                         <p><strong>Phone:</strong> {job.phoneNumber}</p>
//                       </>
//                     )}
//                     <p><strong>Location:</strong> {job.location}</p>
//                     <p><strong>Job Type:</strong> {job.jobType}</p>
//                     <p><strong>Submitted:</strong> {new Date(job.createdAt).toLocaleString()}</p>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p className="text-gray-600 text-center">No jobs submitted yet.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ApplyJob;

































import { useState, useEffect } from 'react';
import axios from 'axios';

const ApplyJob = () => {
  const [mode, setMode] = useState('seeker'); // 'seeker' for job seeker, 'employer' for job employer
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    companyDescription: '',
    companyCategory: '',
    position: '',
    email: '',
    phoneNumber: '',
    whatsappNumber: '',
    companyPhoneNumber: '',
    companyWhatsappNumber: '',
    location: '',
    jobType: '',
    jobResponsibilities: '',
  });
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const type = mode === 'seeker' ? 'apply job-jobseekers' : 'hire for job-jobEmployer';
    const submissionData = { ...formData, type };
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}submit`, submissionData);
      console.log('Submission response:', response.data);
      alert(response.data.message || 'Form submitted successfully!');
      fetchJobs(); // Refresh the job list after submission
      setFormData({
        firstName: '',
        lastName: '',
        companyName: '',
        companyDescription: '',
        companyCategory: '',
        position: '',
        email: '',
        phoneNumber: '',
        whatsappNumber: '',
        companyPhoneNumber: '',
        companyWhatsappNumber: '',
        location: '',
        jobType: '',
        jobResponsibilities: '',
      });
    } catch (error) {
      console.error('Error submitting form:', error.response?.data || error.message);
      alert(error.response?.data?.message || 'Error submitting form.');
    } finally {
      setLoading(false);
    }
  };

  const fetchJobs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}jobs`);
      setJobs(response.data);
    } catch (error) {
      console.error('Error fetching jobs:', error);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-start p-4">
      <div className="bg-blue-100 p-6 rounded-t-lg shadow-lg w-full" style={{ marginTop: '64px', maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' }}>
        <h1 className="text-blue-800 text-2xl font-bold mb-6 text-center">Apply Job</h1>
        <div className="flex justify-center mb-6">
          <button
            onClick={() => setMode('seeker')}
            className={`px-6 py-3 rounded-l-md text-white font-semibold ${mode === 'seeker' ? 'bg-blue-600' : 'bg-blue-300'}`}
          >
            Looking for Job
          </button>
          <button
            onClick={() => setMode('employer')}
            className={`px-6 py-3 rounded-r-md text-white font-semibold ${mode === 'employer' ? 'bg-blue-600' : 'bg-blue-300'}`}
          >
            Hire Person
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          {mode === 'seeker' ? (
            <>
              <div>
                <label className="block text-gray-700 text-lg">First name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter First name"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Last name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter Last name"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter Phone Number"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Whatsapp Number</label>
                <input
                  type="tel"
                  name="whatsappNumber"
                  value={formData.whatsappNumber}
                  onChange={handleChange}
                  placeholder="Enter Whatsapp Number"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter your location"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Which type of job are you looking for</label>
                <select
                  name="jobType"
                  value={formData.jobType}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                >
                  <option value="">Select option</option>
                  <option value="UI/UX">UI/UX</option>
                  <option value="Dev Ops">Dev Ops</option>
                </select>
              </div>
            </>
          ) : (
            <>
              <div>
                <label className="block text-gray-700 text-lg">Company name</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Enter Company name"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">What does the company do</label>
                <textarea
                  name="companyDescription"
                  value={formData.companyDescription}
                  onChange={handleChange}
                  placeholder="Describe what the company does"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  rows={3}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Category of the company</label>
                <select
                  name="companyCategory"
                  value={formData.companyCategory}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                >
                  <option value="">Select category</option>
                  <option value="Technology">Technology</option>
                  <option value="Finance">Finance</option>
                  <option value="Healthcare">Healthcare</option>
                  <option value="Education">Education</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Position of the person posting</label>
                <input
                  type="text"
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  placeholder="Enter your position in the company"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Contact Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter Last name"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter Phone Number"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Company Phone Number</label>
                <input
                  type="tel"
                  name="companyPhoneNumber"
                  value={formData.companyPhoneNumber}
                  onChange={handleChange}
                  placeholder="Enter Company Phone Number"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Company Whatsapp Number</label>
                <input
                  type="tel"
                  name="companyWhatsappNumber"
                  value={formData.companyWhatsappNumber}
                  onChange={handleChange}
                  placeholder="Enter Company Whatsapp Number"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter your location"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">Which type of job did you want to hire for</label>
              
                  <input
                  type="text"
                 name="jobType"
                   value={formData.jobType}
                  onChange={handleChange}
                  placeholder="Enter your location"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-lg">What responsibility for the job being posted by the company</label>
                <textarea
                  name="jobResponsibilities"
                  value={formData.jobResponsibilities}
                  onChange={handleChange}
                  placeholder="Describe the responsibilities for this job"
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  rows={4}
                  required
                />
              </div>
            </>
          )}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
        <div className="mt-8">
          <h2 className="text-2xl font-semibold text-blue-800 mb-4 text-center">Submitted Jobs</h2>
          {jobs.length > 0 ? (
            <ul className="space-y-4">
              {jobs.map((job) => (
                <li key={job._id} className="p-4 bg-white rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold">{job.type.includes('jobseekers') ? 'Job Seeker Details' : 'Job Posting'}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                    <p><strong>Type:</strong> {job.type}</p>
                    {job.type.includes('jobseekers') ? (
                      <>
                        <p><strong>First Name:</strong> {job.firstName}</p>
                        <p><strong>Last Name:</strong> {job.lastName}</p>
                        <p><strong>Email:</strong> {job.email}</p>
                        <p><strong>Phone:</strong> {job.phoneNumber}</p>
                        <p><strong>Whatsapp:</strong> {job.whatsappNumber || 'N/A'}</p>
                      </>
                    ) : (
                      <>
                        <p><strong>Company:</strong> {job.companyName}</p>
                        <p><strong>Company Description:</strong> {job.companyDescription}</p>
                        <p><strong>Company Category:</strong> {job.companyCategory}</p>
                        <p><strong>Position:</strong> {job.position}</p>
                        <p><strong>Contact Name:</strong> {job.lastName}</p>
                        <p><strong>Email:</strong> {job.email}</p>
                        <p><strong>Phone:</strong> {job.phoneNumber}</p>
                        <p><strong>Company Phone:</strong> {job.companyPhoneNumber || 'N/A'}</p>
                        <p><strong>Company Whatsapp:</strong> {job.companyWhatsappNumber || 'N/A'}</p>
                      </>
                    )}
                    <p><strong>Location:</strong> {job.location}</p>
                    <p><strong>Job Type:</strong> {job.jobType}</p>
                    {job.type.includes('jobEmployer') && (
                      <p><strong>Job Responsibilities:</strong> {job.jobResponsibilities}</p>
                    )}
                    <p><strong>Submitted:</strong> {new Date(job.createdAt).toLocaleString()}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-600 text-center">No jobs submitted yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApplyJob;